import "./styles.scss";

import { FaSync } from "react-icons/fa";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  getFormDashboard,
  getFormDashboardDetails,
  getRefreshActiveCampaign,
} from "../../../store/middleware/methodology.middleware";
import ModalDetailReportCSCM from "../ModalDetailReportCSCM";
import PlaceholderText from "../../Placeholder/PlaceholderText";
import { decryptIfEncrypted } from "../../../utils/fieldDecryptor";

const ReportCSCM = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);
  const { reportAllCMCS } = useSelector((state) => state.methodologyReducer);

  const [reportDetail, setReportDetail] = useState([]);
  const [showModalDetail, setShowModalDetail] = useState(false);

  const getDataDashboard = async () => {
    const payload = { status: ["'pendent'", "'pendent-delayed'"] };
    await dispatch(getFormDashboard(payload));
  };

  const getDataDashboardDetails = async (teacherId) => {
    const payload = { status: ["'pendent'", "'pendent-delayed'"], teacherId };
    await dispatch(getFormDashboardDetails(payload)).then((resp) => {
      setReportDetail(resp);
      setShowModalDetail(true);
    });
  };

  const pendentConters = reportAllCMCS?.reduce((acc, item) => {
    const qtdStatus = item.statuses
      .filter((status) => status.status === "pendent")
      .reduce((sum, status) => sum + status.qtd, 0);
    return acc + qtdStatus;
  }, 0);

  const pendentDelayedConters = reportAllCMCS?.reduce((acc, item) => {
    const qtdStatus = item.statuses
      .filter((status) => status.status === "pendent-delayed")
      .reduce((sum, status) => sum + status.qtd, 0);
    return acc + qtdStatus;
  }, 0);

  const handleUpdateActiveCampaign = async () => {
    await dispatch(getRefreshActiveCampaign());
  };

  const CardReport = (item, index) => (
    <div key={index} className="cardReport">
      <div className="cardReportInfo">
        <p className="nameTeacher">{decryptIfEncrypted(item?.teacher)}</p>
        <p className="cardFill">
          <strong>{item?.statuses.find((item) => item.status === "pendent")?.qtd ?? 0} </strong> formularios a preencher
        </p>
        <p className="cardPendent">
          <strong>{item?.statuses.find((item) => item.status === "pendent-delayed")?.qtd ?? 0}</strong> fora do limite
        </p>
      </div>

      <div className="actions">
        <button type="button" onClick={() => getDataDashboardDetails(item?.teacherId)}>
          {t("DETAIL")}
        </button>
      </div>
    </div>
  );

  useEffect(() => {
    getDataDashboard();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="containerReportCSCM">
      <div className="counters">
        <div className="countersInfos">
          <div className="cardInfo counterFill">
            <strong>{pendentConters}</strong> {t("FORMS_FILL")}
          </div>

          <div className="cardInfo counterPendent">
            <strong>{pendentDelayedConters}</strong> {t("OUT_OF_LIMIT")}
          </div>
        </div>

        {user?.role === "companyManager" && (
          <button className="buttonUpdate" onClick={handleUpdateActiveCampaign}>
            <FaSync color="#004fff" />
            {t("UPDATE_SCREEN")}
          </button>
        )}
      </div>

      <div className="cards">{reportAllCMCS?.map((item, index) => CardReport(item, index))}</div>

      <p>{reportAllCMCS?.length === 0 && <PlaceholderText label="No results" />}</p>

      <ModalDetailReportCSCM data={reportDetail} showModal={showModalDetail} setShowModal={setShowModalDetail} />
    </div>
  );
};

export default ReportCSCM;
